export default function (context, val) {
    context.commit('form/clean');
    context.commit('list/clean');
}